export default __webpack_public_path__ + "static/media/resource.61ff8ba7.svg";